import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, LoadingController, ToastController} from 'ionic-angular';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';

import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";

import { ListFormResponsePageDynamic } from '../index';
import { UserMyRadiant as User } from '../../../providers';

import { Form } from '../../../providers/survey'

@Component({
  selector   : 'page-form',
  templateUrl: 'index.html'
})
export class FormPage {

  form       : any = {}
  form_value : any = {}
  survey_form: FormGroup;

  user_data  : any = {};
  data : any={};

  embed_form    : boolean = false;
  url_embed_form: SafeResourceUrl;

  loading : any;

  empty_field_required = 0;
  TY_entry_count = {
    today     : 0,
    yesterday : 0
  };
  entry_for = "today";

  constructor(
    public navCtrl    : NavController,
    public alertCtrl  : AlertController,
    public toastCtrl  : ToastController,
    public loadingCtrl: LoadingController,
    public navParams  : NavParams,
    public formApi    : Form,
    public userApi    : User,
    public formBuilder: FormBuilder,

    private domSanitizer : DomSanitizer

  ) {
    this.form = this.navParams.get('form');
    this.data = this.navParams.get('data');
    this.TY_entry_count = this.navParams.get('TY_entry_count');

    this.user_data = this.userApi.data;

    this.url_embed_form = this.transformUrl(this.form.form_url_frame);
    console.log("Form_detail => ", this.form);
    console.log("Form_data   => ", this.data);
    console.log("todays entry => ", this.TY_entry_count.today);
    console.log("yesterdas entry => ", this.TY_entry_count.yesterday);
    if(this.TY_entry_count.today > 0 && this.TY_entry_count.yesterday == 0){
      this.entry_for = "yesterday"
    }
  }

  ionViewWillEnter(){
    if(this.form.form_url_frame!=null){
      this.embed_form = true;
    }else{
      this.form.fields = this.pushFields();
      if(this.data != undefined){
        this.form_value = JSON.parse(this.data.data);
      }
    }
  }

  showLoading(){
    this.loading = this.loadingCtrl.create({
      content : 'Please wait . . .'
    });
    this.loading.present();
  }
  presentToast(msg){
    this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top'
    }).present();
  }
  //transform to safe URL
  transformUrl(url) {
    return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
  }

  // getFields() {
  //   this.showLoading();
  //   let params = {
  //     form_id : this.form.id
  //   };
  //   this.formApi.getFields(params).subscribe((resp:any) => {
  //     console.log("resp getFields => ", resp.data);
  //     this.form.fields = this.pushFields(resp.data);
  //     this.loading.dismiss();
  //   });
  // }

  pushFields(){
    let fields:any= JSON.parse(this.form.form_fields);
    let new_field = [];
    fields.forEach(field => {
      let temp_field: any = field;

      // cek atribut
      if (field.type == undefined || field.name == undefined || field.label == undefined) {
        return;
      }

      temp_field.label_position = (field.label_position == undefined) ? "stacked" : field.label_position;
      temp_field.placeholder    = (field.placeholder == undefined) ? "" : field.placeholder;
      temp_field.readonly       = (field.readonly == 1) ? true : false;
      temp_field.disable        = (field.disable == 1) ? true : false;
      temp_field.required       = (field.required == 1) ? true : false;
      temp_field.auto_capitalized = (field.auto_capitalized == 1) ? true : false;
      temp_field.maxlength      = (field.maxlength == undefined) ? 500 : field.maxlength;

      // if(temp_field.type=="select"){
      //   temp_field.options = JSON.parse(temp_field.options);
      // }

      new_field.push(temp_field);

    });

    console.log("new_field => ",new_field);
    return new_field;
  }

  // getFormValidasi(){
  //   var fields = new Array(1,2);
  //   let temp_field :any;
  //   // {
  //   //   oldPassword    : ['', Validators.required],
  //   //   password    : ['', Validators.required],
  //   //   confirmPassword: ['', Validators.required],
  //   // }
  //   this.form.fields.forEach(field => {
  //       temp_field.item = field.name;
  //       fields.push(temp_field);
  //   });

  //   const arrayToObject = (array) => array.reduce((obj, item) =>{
  //     obj[item.item] = [''];
  //     return obj;
  //   },{});


  //   console.log("validasi form => ", fields);
  // }


  submit(){
    let confirm = this.alertCtrl.create({
      title: 'Confirm',
      subTitle: 'Save your response ?',
      buttons: [
        {
          text: 'Cancel',
          handler: () => {
            console.log("tidak clicked");
          }
        },
        {
          text: 'Yes',
          handler: () => {
            console.log("yes clicked");
            this.save();
          }
        }
      ]
    });
    confirm.present();
  }

  public save(){
    this.showLoading();
    this.empty_field_required = 0;

    this.form.fields.forEach(field => {
      if(field.required && this.form_value[field.name]==undefined || field.required && this.form_value[field.name]==""){
        ++this.empty_field_required;
      }
    });
    console.log("field required kosong =>", this.empty_field_required);

    let params:any={};    
        if(this.data != undefined){
          params = this.data;
        }          
        params.data = JSON.stringify(this.form_value);
        params.form_name    = this.form.form_name;
        params.form_title   = this.form.form_title;
        params.form_id      = this.form.id;
        // params.created_by   = this.profile.user_attribute.id;
        // params.creator_name = this.profile.user_attribute.name;
        params.created_by  = this.user_data.Employee_ID;
        // params.creator_name= 'Pidegso';
        // if(this.entry_for == 'yesterday'){
        //   params.backdate = 1
        // }else{
        //   params.backdate = 0
        // }

        console.log("param send => ",params);

      if(this.empty_field_required > 0){
        this.presentToast("masih ada field required yang kosong ! ");
        this.loading.dismiss();
      }else{
        if(params.form_id == 7 || params.form_id == 8){
          params.idx = ""
        }
        this.formApi.post(params).subscribe((resp:any) => {
          this.loading.dismiss();
          this.presentToast(resp.msg);
          this.navCtrl.pop();
        }, (err) => {
          this.loading.dismiss();     
        });
      }

  }
  
  // save(){
  //     this.showLoading();

  //     let params = {
  //       form_id : this.form.id,
  //       response: JSON.stringify(this.form_value)
  //     }
  //     this.formApi.post(params).subscribe((resp:any) => {    
  //       this.loading.dismiss();
  //       if(resp.success){
  //         this.presentToast(resp.msg);
  //       }else{
  //         let alert = this.alertCtrl.create({
  //           title: 'Gagal Menyimpan',
  //           subTitle: resp.msg,
  //           buttons: ['Dismiss']
  //         });
  //         alert.present();
  //       }
  //     },(err) => {
  //       this.presentToast('Error');
  //       this.loading.dismiss();
  //     });
  // }

  // closePage(){
  //   this.navCtrl.pop();
  // }
  closePage(){
    this.confirmLeave();
  }

  //close form confirmation
  // async ionViewCanLeave() {
  //   const shouldLeave = await this.confirmLeave();
  //   return shouldLeave;
  // }
  // confirmLeave(): Promise<Boolean> {
  //   let resolveLeaving;
  //   const canLeave = new Promise<Boolean>(resolve => resolveLeaving = resolve);
  //   const alert = this.alertCtrl.create({
  //     title: 'Confirm leave',
  //     message: 'Do you want to leave the page?',
  //     buttons: [
  //       {
  //         text: 'No',
  //         role: 'cancel',
  //         handler: () => resolveLeaving(false)
  //       },
  //       {
  //         text: 'Yes',
  //         handler: () => resolveLeaving(true)
  //       }
  //     ]
  //   });
  //   alert.present();
  //   return canLeave
  // }
  confirmLeave(){
    const alert = this.alertCtrl.create({
      title: 'Confirm leave',
      message: 'Do you want to leave the page?',
      buttons: [
        {
          text: 'No',
          role: 'cancel',
          handler: () => {
            
          }
        },
        {
          text: 'Yes',
          handler: () => {
            this.navCtrl.pop()
          }
        }
      ]
    });
    alert.present();
  }


}


// WEBPACK FOOTER //
// ./src/pages/dynamic_form/form/index.ts